import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class CompanyVendorStatusChange extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static CompanyVendorStatusChangeProperties: (
    | {
        property: keyof CompanyVendorStatusChange;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyVendorStatusChange;
        type: 'alias';
      }
    | {
        property: keyof CompanyVendorStatusChange;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'VendorId', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'oldViveStatus', type: 'column', dataType: 'string' },
    { property: 'newViveStatus', type: 'column', dataType: 'string' },
    { property: 'oldViveSubStatus', type: 'column', dataType: 'string' },
    { property: 'newViveSubStatus', type: 'column', dataType: 'string' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },
    { property: 'ExemptVendorId', type: 'column', dataType: 'number' },
    { property: 'ClientRegisteredVendorId', type: 'column', dataType: 'number' }
  ];

  static {
    CompanyVendorStatusChange.CompanyVendorStatusChangeProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          CompanyVendorStatusChange.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          CompanyVendorStatusChange.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          CompanyVendorStatusChange.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(
    CompanyVendorStatusChangeObject: Partial<CompanyVendorStatusChange>
  ) {
    super();

    CompanyVendorStatusChange.CompanyVendorStatusChangeProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = CompanyVendorStatusChangeObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  VendorId?: number | null;
  CompanyId?: number;
  oldViveStatus?: string | null;
  newViveStatus?: string | null;
  oldViveSubStatus?: string | null;
  newViveSubStatus?: string | null;
  createdAt?: Date;
  updatedAt?: Date;
  ExemptVendorId?: number | null;
  ClientRegisteredVendorId?: number | null;
}
